module.exports = __webpack_public_path__ + "img/step-4@2x.a4f60a85.png";